import { requestJson } from "../api/apiClient";
import { trackDealerViewed, trackBuyerEvent } from "../utils/buyerAnalytics";
import { normalizeDealerProfileFromApi } from "../utils/dealerProfile";

const PUBLIC_BASE = "/api/v1/automap";

async function mapDealerResponse(response) {
  if (!response) return response;
  if (Array.isArray(response.dealers)) {
    return {
      ...response,
      dealers: response.dealers.map((item) => normalizeDealerProfileFromApi(item)),
    };
  }
  if (Array.isArray(response.items)) {
    return {
      ...response,
      items: response.items.map((item) => normalizeDealerProfileFromApi(item)),
    };
  }
  if (response.dealer) {
    return {
      ...response,
      dealer: normalizeDealerProfileFromApi(response.dealer),
    };
  }
  if (response.id || response.slug || response.businessName) {
    return normalizeDealerProfileFromApi(response);
  }
  return response;
}

export async function fetchPublicDealers(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") qs.set(key, value);
  });
  const query = qs.toString();
  const response = await requestJson(`${PUBLIC_BASE}/dealers${query ? `?${query}` : ""}`);
  return mapDealerResponse(response);
}

export async function fetchPublicDealerBySlug(dealerSlug) {
  const response = await requestJson(`${PUBLIC_BASE}/dealers/${encodeURIComponent(dealerSlug)}`);
  return mapDealerResponse(response);
}

export function fetchPublicDealerInventory(dealerSlug, params = {}) {
  const qs = new URLSearchParams(params).toString();
  return requestJson(
    `${PUBLIC_BASE}/dealers/${encodeURIComponent(dealerSlug)}/inventory${qs ? `?${qs}` : ""}`
  );
}

export async function fetchDealerProfileMapPins(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") qs.set(key, value);
  });
  const query = qs.toString();
  const response = await requestJson(`${PUBLIC_BASE}/dealer-profiles/map${query ? `?${query}` : ""}`);
  return mapDealerResponse(response);
}

const DEALER_EVENT_BRIDGE = {
  dealer_profile_viewed: "dealer_profile_viewed",
  dealer_directory_viewed: "dealer_directory_viewed",
  dealer_contact_clicked: "dealer_contact_clicked",
  dealer_whatsapp_clicked: "dealer_whatsapp_clicked",
  dealer_listing_clicked: "dealer_inventory_listing_clicked",
  dealer_inventory_card_clicked: "dealer_inventory_card_clicked",
  dealer_inventory_viewed: "dealer_inventory_viewed",
  dealer_trust_panel_viewed: "dealer_trust_panel_viewed",
};

export function trackDealerProfileEvent(eventType, metadata = {}) {
  const eventName = DEALER_EVENT_BRIDGE[eventType] || eventType;
  if (eventName === "dealer_directory_viewed") {
    trackDealerViewed({ ...metadata, pageType: "dealer_directory" });
    return;
  }
  if (eventName === "dealer_profile_viewed") {
    trackDealerViewed({ ...metadata, pageType: "dealer_profile" });
    return;
  }
  trackBuyerEvent(eventName, { sourceComponent: "dealer_public", ...metadata });
}
